import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import getUserPreferredViewType from './getUserPreferredViewType';
import setUserPreferredViewType from './setUserPreferredViewType';
import { FilePickerUserConfiguration } from 'owa-filepicker';
import {
    setPreferredActionForCloudFile,
    setPreferredActionForGroupsFile,
} from './setUserPreferredAction';

export default function createFilePickerUserConfiguration(): FilePickerUserConfiguration {
    const configuration = getUserConfiguration();

    const filePickerConfiguration: FilePickerUserConfiguration = {
        preferredViewType: {
            value: getUserPreferredViewType(),
            valueSetter: setUserPreferredViewType,
        },
        attachOrShareCloudFiles: {
            value: configuration.ViewStateConfiguration.AttachOrShareCloudFiles,
            valueSetter: setPreferredActionForCloudFile,
        },
        attachOrShareGroupsFiles: {
            value: configuration.ViewStateConfiguration.AttachOrShareGroupsFiles,
            valueSetter: setPreferredActionForGroupsFile,
        },
    };

    return filePickerConfiguration;
}
